import { render, staticRenderFns } from "./AuthorAffairsSection.vue?vue&type=template&id=342eae28&"
import script from "./AuthorAffairsSection.vue?vue&type=script&lang=js&"
export * from "./AuthorAffairsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports